import { Box, Picture, Shimmer, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import ArticleSection from "./article-section"
import Breadcrumb from "./breadcrumb"
import fetchArticle from "./hoc/fetch-article"
import ShareArticle from "./share-article"

const Heading = styled(Typography).attrs({
  as: "h1",
})`
  color: black;
  font-size: 30px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 24px;
  margin-top: 0;
  ${(props) => props.theme.mediaQueries.tablet`
    margin-bottom: 32px;
  `}
`

const Container = styled(Box)`
  margin: auto;
  width: 100%;
  ${(props) => props.theme.mediaQueries.desktop`
    width: 900px;
  `}
`

const Article = ({ article, isLoading }) => {
  return (
    <>
      <Breadcrumb article={article.title} isLoading={isLoading} />
      {isLoading ? (
        <>
          <Shimmer height="30px" mb={{ _: 3, tablet: 4 }} width="100%" />
          <Shimmer
            mb={{ _: 2, tablet: 6 }}
            pb={{ _: "65.89%", tablet: "40.32%" }}
            width="100%"
          />
          <Shimmer
            height="80vh"
            mx="auto"
            width={{ _: "100%", desktop: "900px" }}
          />
        </>
      ) : (
        <>
          <Heading>{article.title}</Heading>
          {article.cover_image && (
            <Box mb={{ _: 2, tablet: 6 }}>
              <Picture
                alt={article.cover_image.alt}
                fallback={article.cover_image.fallback}
                srcSet={article.cover_image.srcSet}
              />
            </Box>
          )}
          <Container>
            {article.sections &&
              article.sections.map((section, i) => (
                <ArticleSection key={i} section={section} />
              ))}
          </Container>
          <ShareArticle article={article} />
        </>
      )}
    </>
  )
}

Article.propTypes = {
  article: PropTypes.object,
  isLoading: PropTypes.bool,
}

export default fetchArticle(Article)
